<template>
  <div class="tile-container container" :class="
    hasNoAccess(model) ? 'no-access' : 
    userHasAccess(model)? 'active-access' :
    hasLastAccess(model) ? 'last-access' : 
    'unknown-access'">
    <!-- <span class="has-no-access-container" v-if="hasNoAccess(model)">
      <font-awesome-icon icon="circle"/>
      <p v-if="hasLastAccess(model)" class="access-text">Last accessed : {{model.access.last_accessed | timestampToDate}}</p>
      <p v-else class="access-text">No access</p>
    </span>
    <span class="has-access-container" v-else-if="userHasAccess(model)">
      <font-awesome-icon icon="circle"/>
      <p v-if="hasLastAccess(model)" class="access-text">Last accessed : {{model.access.last_accessed | timestampToDate}}</p>
      <p v-else class="access-text">Access</p>
    </span>
    <span class="has-last-access-container" v-else-if="hasLastAccess(model)">
      <font-awesome-icon icon="circle"/>
      <p class="last-access-text">Last accessed : {{model.access.last_accessed | timestampToDate}}</p>
    </span> -->
    <div class="row">
      <div class="col-12">
        <div class="icon-container">
          <router-link title="View details" :to="'/view-app/'+model.id">
            <img alt="app icon" v-lazy="getAppIcon(model)" />
          </router-link>
          <div class="view-details-icon">
            <font-awesome-icon class="fav-icon" v-if="model.isFavorite" @click="removeFavorite()" :icon="['fas', 'star']" title="Remove from favorites"/>
            <font-awesome-icon class="fav-icon" v-else @click="addFavorite()" :icon="['far', 'star']" title="Add to favorites"/>
          </div>
        </div>
        <div class="info-container">
          <router-link class="app-title-link" title="View details" :to="'/view-app/'+model.id">
            <p class="info-content" :class="useLineClamp()?'line-clamp':''" >
              <strong>{{model.title || '&nbsp;'}}</strong><br>
              <span title="View details" v-html="sanitizer(model.short_desc) || '&nbsp;'"></span>
            </p>
          </router-link>
        </div>
        <div class="action-container">
          <div class="row">
            <div class="col-6 pr-0">
              <tile-link v-if="model.links[0]" :app="model" :model="model.links[0]" :fullWidth="true"></tile-link>
            </div>
            <div class="col-6 pl-0">
              <root-link :app="model"></root-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import TileLink from "@/components/TileLink";
import util from '@/util'
import api from '@/api'
import AppHandlerMixin from '@/mixins/AppHandlerMixin'
import * as CONSTANTS from '../constants.js'
import RootLink from "@/components/RootLink";
import Sanitizer from 'sanitize-html'
import Platform from "platform";

export default {
  name: "Tile",
  props: {
    tileModel: Object,
    viewId: String,
    categoryId: String
  },
  components: {
    TileLink,
    RootLink
  },
  mixins: [
    AppHandlerMixin
  ],
  computed: {
    model() {
      return this.tileModel;
    }
  },
  data: function() {
    return {
      CONSTANTS,
      sanitizer : Sanitizer,
      platform: Platform
    };
  },
  mounted() {
  },
  methods: {
    ...mapActions(["addAlert"]),
    async addFavorite() {
      this.model.isFavorite = true

      try {
        let data = {
          appId : this.model.id
        }
        await api.postFavorite(data)
      } catch (err) {
        console.log("Error adding favorite", err)
        this.addAlert(util.createAlert('',CONSTANTS.ERROR_MSGS.FAVORITES_ERROR,CONSTANTS.ALERT_CONTEXT.DANGER));
        this.model.isFavorite = false
      }

    },
    async removeFavorite() {
      this.model.isFavorite = false
      
      try {
        await api.deleteFavorite(this.model.id)
      } catch (err) {
        console.log("Error deleting favorite", err)
        this.addAlert(util.createAlert('',CONSTANTS.ERROR_MSGS.FAVORITES_ERROR,CONSTANTS.ALERT_CONTEXT.DANGER));
        this.model.isFavorite = true
      }

    },
    useLineClamp() {
      return !(this.platform && this.platform.name == "Safari")
    }
  }
};
</script>

<style scoped>
.tile-container {
  width: 100%;
  min-height: 175px;
  max-height: 175px;
  border-radius: 3px;
  border: 1px #64788d solid;
  
}
.app-title-link{
  color: #000000;
}
.app-title-link:hover{
  text-decoration: none;
}

.icon-container {
  width: 35px;
  margin-top: 15px;
  margin-bottom: 5px;
}
.icon-container img {
  width: 35px;
  max-height: 35px;
}
.info-container {
  max-height: 75px;
  min-height: 75px;
  margin-bottom: 10px;
  overflow: hidden;
}
.info-content strong {
  font-size: 14px;
  font-weight: bold;
}
.info-content {
  font-size: 12px;
  color: #000000;
  margin-bottom: 8px;
  overflow-x: hidden;
  overflow-y: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.line-clamp {
  line-clamp: 4;
  -webkit-line-clamp: 4;  
}

.action-container a {
  font-size: 10px;
  color: #0696d7;
}
.action-container .link-container {
  line-height: 18px;
  margin-top: 10px;
}
.link-container .bordered {
  border-right: 1px solid #5f60ff;
}
.view-details-icon {
  position: absolute;
  color: var(--secondary-color);
  top: 11px;
  right: 15px;
}
.view-details-icon .fav-icon {
  cursor: pointer;
}
.view-details-icon a {
  color: var(--secondary-color);
}
.cancel-btn {
  background: transparent;
  border: none;
  color: red;
  font-size: 14px;
  float: right;
}
@media (max-width: 991px) {
  .tile-container {
    min-height: 175px;
    max-height: 175px;
  }
}
@media (max-width: 1199px) {
  .link-container .bordered {
    border-right: none;
  }
}
/* 
/** Access Styles **/
/* .last-access {
  border-top: 7px #0696d7 solid;
}
.active-access {
  border-top: 7px #7ed321 solid;
}
.no-access {
  border-top: 7px #999999 solid;
}
.last-access-text {
  font-size: 11px;
  color: #0696d7;
  float: left;
  padding-right: 5px;
  font-weight: bold;
}
.has-access-container {
  position: absolute;
  top: 15px;
  left: 20px;
}
.has-access-container svg {
  width: 7px;
  float: left;
  color: #7ed321;
  margin-right: 3px;
}
.has-access-container .access-text {
  font-size: 11px;
  color: #7ed321;
  float: left;
  padding-right: 5px;
  font-weight: bold;
}

.has-last-access-container {
  position: absolute;
  top: 15px;
  left: 20px;
}
.has-last-access-container svg {
  width: 7px;
  float: left;
  color: #0696d7;
  margin-right: 3px;
}
.has-last-access-container .access-text {
  font-size: 11px;
  color: #0696d7;
  float: left;
  padding-right: 5px;
  font-weight: bold;
}

.has-no-access-container {
  position: absolute;
  top: 15px;
  left: 20px;
}
.has-no-access-container svg {
  width: 7px;
  float: left;
  color: #999999;
  margin-right: 3px;
}
.has-no-access-container .access-text {
  font-size: 11px;
  color: #999999;
  float: left;
  padding-right: 5px;
  font-weight: bold;
} 

.unknown-access {
  padding-top: 7px;
} */
</style>
